import { render } from "./JoinPublicationEmail.vue.js?vue&type=template&id=3cd4dcc2!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationEmail.vue?vue&type=template&id=3cd4dcc2"
import script from "./JoinPublicationEmail.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationEmail.vue?vue&type=script&lang=js"
export * from "./JoinPublicationEmail.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/join-publication/JoinPublicationEmail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3cd4dcc2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cd4dcc2', __exports__)) {
    api.reload('3cd4dcc2', __exports__)
  }
  
  module.hot.accept("./JoinPublicationEmail.vue.js?vue&type=template&id=3cd4dcc2!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationEmail.vue?vue&type=template&id=3cd4dcc2", () => {
    api.rerender('3cd4dcc2', render)
  })

}


export default __exports__